export default "__VITE_ASSET__CV4W_L8f__"